import { Link } from "react-router-dom";
import { motion } from "motion/react";

const services = [
  {
    title: "Reparación de Persianas",
    description: "Motor, cinta, lamas, persiana eléctrica. Te visitamos en 24h.",
    cta: "→ Ver Persianas",
    to: "/persianas",
    color: "primary",
    rotation: "-rotate-[0.5deg]",
    icon: "ri-window-line",
  },
  {
    title: "Toldos y Pérgolas",
    description: "Instalación y reparación. Motorizados, cofre, extensibles.",
    cta: "→ Ver Toldos",
    to: "/toldos",
    color: "secondary",
    rotation: "rotate-[0.5deg]",
    icon: "ri-umbrella-line",
  },
  {
    title: "Mosquiteras",
    description: "Enrollables, correderas, fijas. Verano sin mosquitos.",
    cta: "→ Ver Mosquiteras",
    to: "/mosquiteras",
    color: "accent",
    rotation: "-rotate-[0.3deg]",
    icon: "ri-bug-line",
  },
];

const colorMap: Record<string, { border: string; text: string; hover: string; iconBg: string }> = {
  primary: { border: "border-primary", text: "text-primary", hover: "hover:text-primary-dark", iconBg: "bg-primary/10 text-primary" },
  secondary: { border: "border-secondary", text: "text-secondary", hover: "hover:text-secondary-dark", iconBg: "bg-secondary/10 text-secondary" },
  accent: { border: "border-accent", text: "text-amber-600", hover: "hover:text-amber-700", iconBg: "bg-accent/20 text-amber-600" },
};

export default function ServicesSection() {
  return (
    <section className="bg-surface-alt py-16 md:py-24">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">
            Nuestros servicios
          </h2>
          <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const c = colorMap[s.color];
            return (
              <motion.div
                key={s.title}
                className={`bg-white rounded-[20px] p-8 ${s.rotation} border-t-[6px] ${c.border} shadow-sm hover:shadow-md transition-shadow`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <div className={`w-12 h-12 ${c.iconBg} rounded-xl flex items-center justify-center mb-5`}>
                  <i className={`${s.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading font-bold text-2xl text-text-primary mb-3">
                  {s.title}
                </h3>
                <p className="font-body text-base text-text-secondary mb-5 leading-relaxed">
                  {s.description}
                </p>
                <Link
                  to={s.to}
                  className={`inline-flex items-center gap-1 font-body font-semibold text-base ${c.text} ${c.hover} underline underline-offset-4 transition-colors`}
                >
                  {s.cta}
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}